import React from "react";

function HomeSvgBlog(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={`${props.activeSidebarMenuItem == 1 ? "#1C64F2" : "#6B7280"}`}
        d="M8.636 1.064a.9.9 0 00-1.272 0l-6.3 6.3a.9.9 0 001.272 1.272l.264-.263V14.3a.9.9 0 00.9.9h1.8a.9.9 0 00.9-.9v-1.8a.9.9 0 01.9-.9h1.8a.9.9 0 01.9.9v1.8a.9.9 0 00.9.9h1.8a.9.9 0 00.9-.9V8.373l.264.263a.9.9 0 001.272-1.272l-6.3-6.3z"
      ></path>
    </svg>
  );
}

export default HomeSvgBlog;
